import styles from '../styles/components/globalData.module.css';

import { useContext, useEffect, useState } from 'react';
import { ReactComponent as MoneyIcon } from "../assets/money.svg";
import { ReactComponent as AddIcon } from "../assets/add.svg";
import { ReactComponent as InfoIcon } from "../assets/components/global_data/info.svg";
import { ReactComponent as GiftIcon } from "../assets/components/global_data/gift.svg";
import { StoreContext } from '..';
import { observer } from "mobx-react-lite";
import moment from 'moment';
import SubLimitModal from './SubLimitModal';
import Spinner from './Spinner';
import { useNavigate } from 'react-router-dom';
import SpecialOfferModal from './SpecialOfferModal';
import { Product } from '../models/product';
import config from "../config";


interface ComponentProps {
};


function GlobalData({}: ComponentProps) {
    const {appStore} = useContext(StoreContext);
    const tg = window.Telegram.WebApp;
    const [modalSubLimit, setModalSubLimit] = useState(false);
    const [specialOfferProduct, setSpecialOfferProduct] = useState(null as Product | null);
    const [modalSpecialOffer, setModalSpecialOffer] = useState(false);
    const [openPaymentWindowSellNotify, setOpenPaymentWindowSellNotify] = useState(localStorage.getItem("openPaymentWindowSellNotify") === "true");
    const [timeLeft, setTimeLeft] = useState(null as number | null);
    const navigate = useNavigate();

    const openPaymentWindow = () => {
        tg.HapticFeedback.impactOccurred("light");
        appStore.openPaymentWindow();
        setOpenPaymentWindowSellNotify(true);
        localStorage.setItem("openPaymentWindowSellNotify", "true");
    };
    
    useEffect(() => {
        if (!appStore.user.next_recovery) {
            return;
        };

        const now = moment().unix();
        const delay = (appStore.user.next_recovery - now) * 1000;
        
        const updateLimit = () => {
            (appStore.user.next_recovery as number) += 1;
            appStore.getUser();
        };

        if (delay > 0) {
            const timer = setTimeout(() => {
                updateLimit();
            }, delay);
    
            return () => clearTimeout(timer);
        } else {
            updateLimit();
        };
    }, [appStore.user.next_recovery]);

    const closeModalSubLimit = () => {
        setModalSubLimit(false);
        tg.HapticFeedback.impactOccurred("light");
    };

    const openModalSubLimit = () => {
        setModalSubLimit(true);
        tg.HapticFeedback.impactOccurred("light");
    };
    
    useEffect(() => {
        if (appStore.products.length === 0) return;

        const savedProductId = localStorage.getItem("specialOfferProductId");
        const savedProduct = savedProductId ? appStore.products.find(p => p.id === savedProductId) : null;

        // Почистит хранилище, но те у кого были спец предложения потеряют их при перезагрузке, в целом ок
        if (savedProductId && !savedProduct) {
            localStorage.removeItem("specialOfferProductId");
        };

        const lastSpecialOfferTime = localStorage.getItem("lastSpecialOfferTimeV2");

        setSpecialOfferProduct(savedProduct ? savedProduct : null);

        console.log(`lastSpecialOfferTime=${lastSpecialOfferTime}`)
        if (lastSpecialOfferTime) {
            console.log(`lastSpecialOfferTime=${lastSpecialOfferTime}`)
            setTimeLeft(config.specialOfferTimeout - (Math.floor(Date.now() / 1000) - Number(lastSpecialOfferTime)));
        };

        // учитываю savedProduct на всякий случай, чтобы избежать гонки
        if (specialOfferProduct !== null || savedProduct) {
            return;
        };
        const approvedChats = appStore.chats.filter(c => c.is_approved === true);
        if (approvedChats.length === 0) return;
        
        const specialOfferProducts = appStore.products.filter(p => p.product_type === 'specialOfferPromocoin');
        if (specialOfferProducts.length === 0) return;
        
        if (lastSpecialOfferTime) {
            const currentTime = Math.floor(Date.now() / 1000);

            if (currentTime - Number(lastSpecialOfferTime) < config.specialOffersPeriod) return;
        };

        const p = specialOfferProducts[Math.floor(Math.random() * specialOfferProducts.length)];
        localStorage.setItem("specialOfferProductId", p.id);
        
        const unixTime = Math.floor(Date.now() / 1000).toString();
        localStorage.setItem("lastSpecialOfferTimeV2", unixTime);
        
        setTimeLeft(config.specialOfferTimeout);

        setSpecialOfferProduct(p);
    }, [appStore.products, appStore.chats]);

    const cancelSpecialOfferModal = () => {
        tg.HapticFeedback.impactOccurred("light"); 
        setModalSpecialOffer(false);
    };

    const openSpecialOfferModal = () => {
        tg.HapticFeedback.impactOccurred("light"); 
        setModalSpecialOffer(true);
    };

    const formatTime = (seconds: number) => {
        const minutes = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${minutes}:${secs.toString().padStart(2, "0")}`;
    };

    const cancelSpecialOffer = () => {
        localStorage.removeItem("specialOfferProductId");
        setSpecialOfferProduct(null);
    };

    // useEffect(() => {
    //     console.log('qq');
    //     if (timeLeft === null) {
    //         return;
    //     };
    //     console.log('qqq');

    //     if (timeLeft <= 0) {
    //         cancelSpecialOffer();
    //         return;
    //     };

    //     const timer = setTimeout(() => {
    //       setTimeLeft(prevTimeLeft => prevTimeLeft as number - 1);
    //     }, 1000);

    //     return () => clearTimeout(timer);
    // }, [timeLeft]);

    return <>
        {specialOfferProduct && modalSpecialOffer && <SpecialOfferModal 
            cancelModal={cancelSpecialOfferModal} 
            product={specialOfferProduct} 
            timeLeft={formatTime(timeLeft as number)}
            cancelSpecialOffer={cancelSpecialOffer}
        />}
        {modalSubLimit && <SubLimitModal cancel={closeModalSubLimit} header={appStore.user.limit <= 0 ? "Лимит подписок исчерпан" : "Лимит подписок"}></SubLimitModal>}
        <div className={styles.global_data}>
            {appStore.user.limit !== undefined && <>
                <div className={styles.balance}>
                    {/* {specialOfferProduct && <div className={styles.gift_container} onClick={openSpecialOfferModal}>
                        <GiftIcon/>
                        <span>{formatTime(timeLeft as number)}</span>
                    </div>} */}
                    {appStore.user.admin === true && <button onClick={() => {tg.HapticFeedback.impactOccurred("heavy"); navigate('/admin/moderation', { replace: true })}} className={styles.moder_button}></button>}    
                    <div className={styles.balance_row}>
                        <span className={styles.gd_balance} onClick={openPaymentWindow}>{appStore.user.balance}<MoneyIcon/></span>
                        <button className={styles.add_balance} onClick={openPaymentWindow}><AddIcon/></button>
                    </div>
                </div>
                {appStore.user.limit !== undefined && <span className={styles.gd_description} onClick={openModalSubLimit}>Вы можете подписаться ещё на {appStore.user.limit} каналов<button onClick={openModalSubLimit}><InfoIcon/></button></span>}
            </>}
            {appStore.user.limit === undefined && <div className={styles.spinner_wrapper}><Spinner/></div>}
        </div>
    </>;
};

export default observer(GlobalData);